"use strict";
// Toolbar should eventually be broken out
// into its own component since it's a generic
// grouping component for buttons/dropdowns/etc
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Toolbar_module_scss_1 = __importDefault(require("./Toolbar.module.scss"));
var Toolbar = function (_a) {
    var items = _a.items, _b = _a.noGap, noGap = _b === void 0 ? false : _b, automationId = _a.automationId;
    if (!items || (items && items.length === 0)) {
        return react_1["default"].createElement(react_1["default"].Fragment, null);
    }
    return (react_1["default"].createElement("div", { className: Toolbar_module_scss_1["default"].toolbar, "data-automation-id": automationId, "data-testid": automationId }, items.map(function (item) { return (react_1["default"].createElement("div", { className: (0, classnames_1["default"])(Toolbar_module_scss_1["default"].toolbarItem, noGap && Toolbar_module_scss_1["default"].noGap), key: item.key }, item.node)); })));
};
exports["default"] = Toolbar;
//# sourceMappingURL=Toolbar.js.map